import { render, staticRenderFns } from "./JTreeDict.vue?vue&type=template&id=2a4fd8fd&"
import script from "./JTreeDict.vue?vue&type=script&lang=js&"
export * from "./JTreeDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports